

























import Vue from 'vue'
import Component from 'vue-class-component'
import MenuIcon from '@/UI/App/Layout/Header/MenuIcon.vue'
import UserMenu from '@/UI/App/Layout/Header/UserMenu.vue'
import LogoutButton from '@/UI/App/Layout/Header/LogoutButton.vue'
import NotificationArea from '@/UI/App/Layout/Header/NotificationArea.vue'

@Component({
  components: {
    MenuIcon,
    UserMenu,
    NotificationArea,
    LogoutButton
  }
})

export default class Header extends Vue {
}
